const f = {
  color: {
    background: {
      default: "#ffffffff",
      cell: "#f9fafaff",
      hover: "#f9fafaff",
      focus: "#ebf5ffff",
      focusIndicator: "#304ddbff",
      selectedHover: "#d1e8ffff",
      alternativeHeader: "#dfe6ebff"
    },
    border: "#dfe6ebff",
    text: "#314351ff",
    typeAction: "#7e8e9eff",
    sortableCell: {
      text: {
        default: "#7e8e9eff",
        sorted: "#314351ff"
      },
      bg: "#f1f3f5ff"
    }
  }
};
export {
  f as table
};
